import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  faCircleCheck,
  faCircleExclamation,
  faCircleInfo,
  faXmark
} from '@fortawesome/free-solid-svg-icons';
import { ToastService, ToastMessage } from './toast.service';

@Component({
  selector: 'app-toast-container',
  standalone: true,
  imports: [CommonModule, FontAwesomeModule],
  templateUrl: './toast-container.component.html',
  styleUrls: ['./toast-container.component.scss']
})
export class ToastContainerComponent {
  toastService = inject(ToastService);

  faCircleCheck = faCircleCheck;
  faCircleExclamation = faCircleExclamation;
  faCircleInfo = faCircleInfo;
  faXmark = faXmark;

  iconFor(t: ToastMessage) {
    switch (t.type) {
      case 'success': return this.faCircleCheck;
      case 'error':   return this.faCircleExclamation;
      default:        return this.faCircleInfo;
    }
  }

  close(id: number) {
    this.toastService.dismiss(id);
  }

  trackById(_idx: number, t: ToastMessage) { return t.id; }
}
